import { atom } from 'jotai';

export const isStatementBannerShownAtom = atom<boolean>(true);

export default {
    isStatementBannerShownAtom,
};
